import React, { useEffect, useState } from 'react'
import { Button, Container, Form, Col, Row, Accordion, Table } from 'react-bootstrap'

import StepHeader from "../../../components/v2/StepHeader"
import DepartmentHeader from "../../../components/v2/DepartmentHeader"
import FocusProgramDialog from '../../../components/v2/FocusProgramDialog'
import RelatedDataDialog from '../../../components/v2/RelatedDataDialog'
import { REVIEW_YEAR_1, REVIEW_YEAR_2, REVIEW_YEAR_3 } from '../../../fastConstants'

const FAST_URL = process.env.REACT_APP_DS_API_URL
const LOG_URL = false

function EditButton(props) {
    return (
        <Button
            onClick={props.onClick}
            variant="success"
            className="w-100"
            size="md"
            id={'program-' + props.programId + '_slo-' + props.sloId}
            >
            Edit
        </Button>
    )
}

function ViewButton(props) {
    return (
        <Button
            onClick={props.onClick}
            variant="link"
            className="w-50"
            size="md"
            id={'program-' + props.programId + '_slo-'+ props.sloId}
            >
            View
        </Button>
    )
}

function CompletedCheckBox(props) {
    return (
        <Form.Check
            type="checkbox"
            onChange={props.onChange}
            id={'program-' + props.programId + '_step-' + props.step}
            name={'program-' + props.programId + '_step-' + props.step}
            aria-label={props.ariaLabel}
            label={props.label}
            value={props.completed}
            defaultChecked={props.defaultChecked}
            disabled={props.disabled}
            />
    )
}

const EMPTY_FOCUS_PROGRAM = {
    "s1q1": "",
}

export default function AssessmentStep1(props) {
    const [programId, setProgramId] = useState(0)

    // Used for FocusProgramDialog
    const [selectedProgram, setSelectedProgram] = useState()
    const [selectedLearningOutcome, setSelectedLearningOutcome] = useState()
    const [stepData, setStepData] = useState(EMPTY_FOCUS_PROGRAM)
    const [stepDataStore, setStepDataStore] = useState({})
    const [showModal, setShowModal] = useState(false)
    
    const [showViewModal, setShowViewModal] = useState(false)
    const [programDataCache, setProgramDataCache] = useState({})
    let prefix = 'program-';
    
    //
    // TODO: We specify the review years in the URL, but we also need to
    //       update them in RelatedDataDialog.js as well.
    //
    useEffect(() => {
        if (programId && !(programId in programDataCache)) {
            let url = FAST_URL + "/program-data?programId=" + programId + "&reviewYear=" + REVIEW_YEAR_1 + "&reviewYear= " + REVIEW_YEAR_2 + "&reviewYear=" + REVIEW_YEAR_3
            if (LOG_URL) console.log(url)
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let tempCache = {...programDataCache}
                tempCache[programId] = data
                setProgramDataCache(tempCache)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [programId])

    useEffect(() => {
        if (selectedLearningOutcome && (selectedLearningOutcome.sloId in stepDataStore)) {
            setStepData({...stepDataStore[selectedLearningOutcome.sloId]})
        } else {
            setStepData({...EMPTY_FOCUS_PROGRAM})
        }
    }, [stepDataStore])

    useEffect(() => {
        if (selectedProgram && (selectedProgram.programId in props.stepDataStore)) {
            setStepDataStore({...props.stepDataStore[selectedProgram.programId]})
        } else {
            setStepData({...EMPTY_FOCUS_PROGRAM})
            setStepDataStore({})
        }
    }, [selectedProgram])

    const handleOpen = (event) => {
        let tokens = event.target.id.split('_')
        let programId = tokens[0].split('-')[1]
        let sloId = tokens[1].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)

        setSelectedProgram(program)
        
        // Update which learning outcome the edit dialog was opened for.
        let slo = props.learningOutcomes[programId].find(lo => lo.sloId == sloId)
        
        setSelectedLearningOutcome({...slo})
        setStepData({...stepDataStore[sloId]})

        setShowModal(true)
    }
    const handleCancel = () => setShowModal(false);
    const handleClose = () => {
        let sloId = selectedLearningOutcome.sloId
        let dirtyDataStore = {...stepDataStore}
        dirtyDataStore[sloId] = {...stepData}
        setStepDataStore({...dirtyDataStore})

        let data = {
            department: props.department,
            program: selectedProgram,
            learningOutcome: selectedLearningOutcome,
            stepDataStore: {...dirtyDataStore},
        }

        props.onStep1DialogSave(data)

        setShowModal(false);
    }

    const handleOpenViewDialog = (event) => {
        let tokens = event.target.id.split('_')
        let programId = tokens[0].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)

        setProgramId(programId)
        setSelectedProgram(program)
        setShowViewModal(true)
    }
    const handleCancelViewDialog = () => setShowViewModal(false)
    const handleCloseViewDialog = () => setShowViewModal(false)

    const isStepComplete = (programId) => {

        // Prevent edit of step if next step is complete
        if (props.step2CompletionData[programId] &&
            props.step2CompletionData[programId].completed) {
            return false
        }

        let result = true
        availableLearningOutcomes[programId].map((slo) => {
            if (programId in props.stepDataStore && slo.sloId in props.stepDataStore[programId]) {
                let text = props.stepDataStore[programId][slo.sloId].s1q1
                if (text.trim().length == 0) {
                    result = false
                }
            } else {
                if (!(programId in props.stepDataStore)) {
                    result = false
                } else if (!(slo.sloId in props.stepDataStore[programId])) {
                    result = false
                }
            }
        })
        return result
    }

    let themeName = props.theme.name
    let availableLearningOutcomes = {}

    props.department.submittedPrograms.map(program => {
        let programMappedSlos = props.mappedSlos[program.programId]
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }
        
        if (program.programId in props.learningOutcomes) {
            props.learningOutcomes[program.programId].map(slo => {
                if (slo.sloId in programMappedSlos) {
                    let mappedSlo = programMappedSlos[slo.sloId]
                    if (mappedSlo.firstTheme === themeName && mappedSlo.firstThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.secondTheme === themeName && mappedSlo.secondThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.thirdTheme === themeName && mappedSlo.thirdThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    }
                }
            })
        }
    })
    
    // defaultTabs is provided to Accordion to expand all accordion items by default.
    //let defaultTabs = Array.from(props.department.submittedPrograms, (p,k) => 'program-' + k)
    let defaultTabs = []
    props.department.submittedPrograms.forEach((p) => {
        if (!(p.programId in props.step1CompletionData && props.step1CompletionData[p.programId].completed)) {
            defaultTabs.push(prefix + p.programId)
        }
    })
    
    return (
        <React.Fragment>
            <StepHeader text={props.stepTitle} />

            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    <p>
                    Use the ‘Edit’ buttons below to record a focus area for 
                    the assessment of each current outcome. This should be a 
                    question, hypothesis, or statement related to student 
                    learning that guides decision making related to the 
                    assessment of each learning outcome in the current 2-year 
                    cycle. Please review background information about Identifying 
                    Focus Areas before continuing: <a href="https://rise.articulate.com/share/lTsJmiNCnURBBed8qLgus23n07AD9UO8" target="_blank" rel="noopener noreferrer">View</a>
                    </p>
                    <p>
                    If you expect that you will want to share the results of your 
                    assessment efforts, either internally within CNM or externally 
                    through publishing or attending conferences, explore turning your 
                    assessment into an Action Research Project.  Depending on your 
                    goals, your may or may not be required to go through the 
                    Institutional Review Board (IRB). <a href="https://livecnm.sharepoint.com/:i:/t/SAAC/EVP0Zb746TNFkR9jFq4NegcB_OLHcK_fy65T-fVuorpTIg?e=xTTE4s" target="_blank" rel="noopener noreferrer">Review IRB Flowchart</a>
                    </p>
                </div>
                <DepartmentHeader department={props.department} />

                <div className="mx-auto">
                    <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                        {
                            props.department.submittedPrograms?.map((p,k) => {
                                if (props.activePrograms[p.programId] === 'yes') {
                                    return (
                                    <Accordion.Item eventKey={prefix + p.programId} key={p.programId}>
                                        <Accordion.Header>
                                            {p.name} {(p.programId in props.step1CompletionData && props.step1CompletionData[p.programId].completed) ? ' - Completed' : ''}
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>Learning Outcome</th>
                                                        <th>
                                                            Question about each learning outcome
                                                            (or goals, predictions, hypothesis)
                                                        </th>
                                                        <th></th>
                                                        <th>Related Data</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        availableLearningOutcomes[p.programId].map((slo, index)  => {
                                                            return (
                                                            <tr key={index}>
                                                                <td style={{width: "40%"}}>
                                                                    {slo.text}
                                                                </td>
                                                                <td style={{width: "40%"}}>
                                                                    {p.programId in props.stepDataStore
                                                                        ? props.stepDataStore[p.programId][slo.sloId]?.s1q1
                                                                        : ""
                                                                    }
                                                                </td>
                                                                <td>
                                                                    <EditButton
                                                                        onClick={handleOpen}
                                                                        programId={p.programId}
                                                                        sloId={slo.sloId}
                                                                        />
                                                                </td>
                                                                <td>
                                                                    <ViewButton
                                                                        onClick={handleOpenViewDialog}
                                                                        programId={p.programId}
                                                                        sloId={slo.sloId}
                                                                        />
                                                                </td>
                                                            </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                            <Container fluid>
                                                <Row>
                                                    <Col 
                                                        md={{span: 8, offset: 3}}
                                                        lg={{span: 12, offset: 3}}
                                                        >
                                                        <CompletedCheckBox
                                                            onChange={props.onStepCompleted}
                                                            programId={p.programId}
                                                            completed={props.step1CompletionData[p.programId]?.completed}
                                                            defaultChecked={props.step1CompletionData[p.programId]?.completed}
                                                            ariaLabel="Step 1 is complete"
                                                            label="By checking this box you are completing Step 1 for your program area"
                                                            step="1"
                                                            disabled={!isStepComplete(p.programId)}
                                                            />
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    )
                                }
                            })
                        }
                        
                    </Accordion>
                </div>
                
                <FocusProgramDialog
                    department={props.department}
                    theme={props.theme}
                    selectedProgram={selectedProgram}
                    selectedLearningOutcome={selectedLearningOutcome}
                    stepData={stepData}
                    stepDataStore={stepDataStore}
                    stepCompletionData={props.step1CompletionData}

                    showModal={showModal}
                    handleCloseDialog={handleClose}
                    handleCancelDialog={handleCancel}
                    handleS1Q1Changed={(e) => setStepData(prevStepData => ({...prevStepData, s1q1: e.target.value}))}
                    />
                <RelatedDataDialog
                    department={props.department}
                    programId={programId}
                    selectedProgram={selectedProgram}
                    programs={props.department.submittedPrograms}
                    programDataCache={programDataCache}
                    showModal={showViewModal}
                    onProgramChanged={(e) => setProgramId(e.target.value)}
                    handleCloseDialog={handleCloseViewDialog}
                    handleCancelDialog={handleCancelViewDialog}
                    />
            </div>
        </React.Fragment>
    )
}
